import config from "@/config";
import i18n from "@/languages";
import { library } from "@fortawesome/fontawesome-svg-core";
// internal icons
import '@fontsource/inter';

import {
    faAngleDown,
    faAngleLeft,
    faAngleRight,
    faAngleUp,
    faArrowUp,
    faCalendarDay,
    faCaretDown,
    faCaretUp,
    faCheck,
    faCheckCircle,
    faExclamationCircle,
    faExclamationTriangle,
    faEye,
    faEyeSlash,
    faInfoCircle,
    faMinus,
    faPencilRuler,
    faPlus,
    faPlusCircle,
    faTag,
    faTrash,
    faUpload,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { Integrations } from "@sentry/tracing";
import * as Sentry from "@sentry/vue";
import VueCompositionAPI from "@vue/composition-api";
import Buefy from "buefy";
import { Chart, registerables } from "chart.js3";
import Vue from "vue";
import InputFacade from "vue-input-facade";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./vee-validate";

Chart.register(...registerables);
Vue.use(VueCompositionAPI);

Sentry.init({
    Vue: Vue,
    dsn: config.sentryDsn,
    environment: process.env.NODE_ENV,
    integrations: [new Integrations.BrowserTracing()],
    logErrors: true,

    // We recommend adjusting this value in production, or using tracesSampler
    // for finer control
    tracesSampleRate: 0.2,
    tracingOptions: {
        trackComponents: true,
    },
});

library.add(
    faCheck,
    faCheckCircle,
    faInfoCircle,
    faExclamationTriangle,
    faExclamationCircle,
    faArrowUp,
    faAngleRight,
    faAngleLeft,
    faAngleDown,
    faAngleUp,
    faEye,
    faEyeSlash,
    faCaretDown,
    faCaretUp,
    faUpload,
    faCalendarDay,
    faPlus,
    faMinus,
    faPlusCircle,
    faTag,
    faPencilRuler,
    faTrash
);

Vue.component("vue-fontawesome", FontAwesomeIcon);

const options = {
    // rename the directive from: v-facade to: v-mask
    name: "mask",

    // use these tokens instead of the default
    tokens: {
        "#": {
            pattern: /\d/,
        },
        A: {
            pattern: /[a-z]/i,
        },
        N: {
            pattern: /[0-9a-z]/i,
        },
        X: {
            pattern: /./,
        },
        B: {
            pattern: /[0-9kK]/i,
        },
    },
};

Vue.use(InputFacade, options);
Vue.use(Buefy, {
    defaultIconComponent: "vue-fontawesome",
    defaultIconPack: "fas",
});
Vue.config.productionTip = false;
Vue.config.devtools = true;

new Vue({
    i18n,
    router,
    store,
    render: (h) => h(App),
}).$mount("#app");
